<template>
  <router-view />
</template>
<script>
import { onMounted } from "vue";
import { useStore } from "vuex";
import { setReplayUserId } from "@/plugins/sessionReplay";

export default {
  name: "App",
  setup() {
    const store = useStore();

    onMounted(() => {
      const url = new URL(window.location.href);
      const shouldResetPopup = url.searchParams.get("popupReset") === "1";

      if (shouldResetPopup) {
        store.commit("setInfoPopUp", null);
        localStorage.removeItem("integratedPopupState");
      }

      const integratedUserVuex = JSON.parse(
        localStorage.getItem("integratedUserVuex"),
      );
      const userInfo = integratedUserVuex?.userInfo;
      const userName = userInfo?.userName;
      if (userName) {
        setReplayUserId(userName);
      }
    });
  },
};
</script>
<style lang="scss"></style>
